export default{
    profiler: 'Profiler Description'
}